import { render, staticRenderFns } from "./regraagendamento.vue?vue&type=template&id=4ae47ab1&"
import script from "./regraagendamento.vue?vue&type=script&lang=js&"
export * from "./regraagendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports